module.exports = __webpack_public_path__ + "img/ico07.dbf6c428.svg";